var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profileImage"},[_c('div',{staticClass:"profileImage-container"},[(_vm.profilePicture === '')?_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":['far', 'user']}}):_c('img',{attrs:{"src":_vm.profileImage,"alt":"Profile picture"}})],1),_c('p',[_vm._v(_vm._s(_vm.user.firstName)+" "+_vm._s(_vm.user.lastName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }